var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.message))]),_c('button',{on:{"click":_vm.fetchData}},[_vm._v("获取后端数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }